import axios from 'axios';

const base = () => (window.location.hostname === 'panel.exuni.ir'
  ? 'https://api.exuni.ir/' : 'http://127.0.0.1:5000/');

export async function packingGet(action, params = {}) {
  const response = await axios.get(`${base()}packing/workflow/${action}`, {
    params,
    headers: { Authorization: `Token ${localStorage.getItem('token') || ''}` },
  });
  return response.data;
}

export async function packingPost(action, data = {}) {
  const response = await axios.post(`${base()}packing/workflow/${action}`, data, {
    headers: { Authorization: `Token ${localStorage.getItem('token') || ''}` },
  });
  return response.data;
}

export function packingError(error) {
  const data = error && error.response && error.response.data;
  if (typeof data === 'string') return data;
  if (Array.isArray(data)) return data.join('، ');
  if (data && data.detail) return data.detail;
  if (data && data.error) return data.error;
  if (data && typeof data === 'object') {
    const first = Object.values(data)[0];
    if (first) return Array.isArray(first) ? first.join('، ') : String(first);
  }
  return 'ارتباط با سرور برقرار نشد. دوباره تلاش کنید.';
}
